import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[together-page-content-dynamic]',
    standalone: false
})
export class TogetherMainContentDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}